export default __webpack_public_path__ + "static/media/profile.94a0c9be.png";